import { BodySmallText } from '@prisjakt/ui/text/variants';
import styled, { css } from 'styled-components';
import { priceLabelStylingType, PriceLabelStyleType } from '../types';

type PriceLabelProps = {
  bold?: boolean;
  styling: priceLabelStylingType;
};

export const PriceLabel = styled(BodySmallText).attrs({
  containerProps: { 'data-test': 'PriceLabel' },
})<PriceLabelProps>(
  props => css`
    font-size: inherit;
    font-weight: ${props.bold ? '600' : 'inherit'};

    ${props.styling === PriceLabelStyleType.PRIMARY &&
      css`
        color: ${props.theme.colors.base700};
      `}

    ${props.styling === PriceLabelStyleType.SECONDARY &&
      css`
        color: ${props.theme.colors.base600};
      `}

    ${props.styling === PriceLabelStyleType.LIGHTEN &&
      css`
        color: ${props.theme.colors.base500};
      `}

    ${props.styling === PriceLabelStyleType.CAMPAIGN &&
      css`
        color: ${props.theme.colors.negative700};
      `}
  `
);
